import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { selectTournamentDifficulty, selectTournamentPositionLocas, selectTournamentRankProgression, } from "../../selectors/selectTournamentInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { PlayerPreferencesPlatformType } from "../../utils/network/generated/protoTypes";
import { utilNumber } from "../../utils/utilNumber";
import { EventType } from "../balancing/types/BalancingCore";
import { BigCharacter } from "../generic/big-character/BigCharacter";
import { ButtonPrimary } from "../generic/common/ButtonPrimary";
import { Icon } from "../generic/icon/Icon";
import { TextLoca } from "../generic/text/TextLoca";
import { actionModalClose, actionModalOpen, actionModalTabSelect } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { actionServerPersistenceSetInfo } from "../server-persistence/actionServerPersistence";
import { TransparentDialogWrapper } from "../transparent-dialog/TransparentDialogWrapper";
import { IdTournamentCategory } from "./IdTournamentCategory";
import { IdTournamentProgression } from "./IdTournamentProgression";
import { mapFullPromotionDemotion } from "./mapFullPromotionDemotion";
var DialogPromoteDemoteDOM = function (_a) {
    var eventId = _a.eventId, tournamentProgressionId = _a.tournamentProgressionId, replacements = _a.replacements, currentLeagueAsString = _a.currentLeagueAsString, onClose = _a.onClose;
    if (eventId === undefined ||
        tournamentProgressionId === undefined ||
        replacements === undefined ||
        currentLeagueAsString === undefined) {
        return React.createElement(React.Fragment, null);
    }
    var mappedData = mapFullPromotionDemotion
        .get(eventId)
        .get(tournamentProgressionId);
    var mirrorX = mappedData.shouldMirrorCharacterX ? "mirrorX" : "";
    var preparedOnClose = function () { return onClose(mappedData.persistenceKey, currentLeagueAsString); };
    return (React.createElement(TransparentDialogWrapper, null,
        React.createElement("div", null,
            React.createElement(BigCharacter, { name: mappedData.characterId, className: "level-up_character-size flex__auto " + mirrorX + " dialog-promote-demote__character" }),
            React.createElement("div", { className: IdStyles.LeaguesPromotionBaloon + " dialog-promote-demote__balloon absolute" },
                React.createElement("div", { className: "flex flex--wrap flex--guts flex--stack h100 w100" },
                    React.createElement("div", { className: "dialog-promote-demote__icon" },
                        React.createElement(Icon, { icon: mappedData.idIcon, styleId: IdStyles.IconExtraLarge })),
                    React.createElement(TextLoca, { id: mappedData.titleId, className: IdStyles.TextBoldSecondaryOutline }),
                    React.createElement(TextLoca, { id: mappedData.descriptionId, className: IdStyles.TextNormal, replacements: replacements }),
                    React.createElement("div", { className: "dialog-promote-demote__button" },
                        React.createElement(ButtonPrimary, { onClick: preparedOnClose },
                            React.createElement("div", { className: "flex flex--guts w100 h100" },
                                React.createElement(TextLoca, { id: IdLoca.leagueMenuCategoryRewards, className: IdStyles.TextButtonDefault })))))))));
};
var mapState = function (state) {
    var tryMatchEventId = function (eventId) {
        var tournamentProgressionId = selectTournamentRankProgression(state, eventId);
        if (tournamentProgressionId !== IdTournamentProgression.NoProgression) {
            var replacements = selectTournamentPositionLocas(state, eventId);
            var currentLeagueAsString = utilNumber.format((selectTournamentDifficulty(state, eventId) || 0) + 1);
            return {
                currentLeagueAsString: currentLeagueAsString,
                eventId: eventId,
                replacements: replacements,
                tournamentProgressionId: tournamentProgressionId,
            };
        }
        return;
    };
    return tryMatchEventId(EventType.PlayerLeague) || tryMatchEventId(EventType.CoopLeague) || {};
};
var mapDispatch = function (dispatch) { return ({
    onClose: function (key, value) {
        dispatch(actionModalClose(IdModal.PromoteDemote));
        dispatch(actionModalOpen(IdModal.TournamentTent));
        dispatch(actionModalTabSelect(IdTournamentCategory.LeagueOverview));
        dispatch(actionServerPersistenceSetInfo({
            key: key,
            platform: PlayerPreferencesPlatformType.PLAT_SHARED,
            value: value,
        }));
    },
}); };
export var DialogPromoteDemote = connect(mapState, mapDispatch)(DialogPromoteDemoteDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/DialogPromoteDemote.tsx
// module id = 2953
// module chunks = 3